import React from 'react';
import { motion } from 'framer-motion';

/**
 * OriginSignatureLine — The 2px structural signature.
 * A stable, continuous line that unifies the interface horizontally.
 */
const OriginSignatureLine: React.FC = () => {
  const MotionDiv = motion.div as any;
  return (
    <div 
      className="origin-signature-line-container"
      style={{
        width: '100%',
        height: 'var(--origin-line-height, 2px)',
        position: 'relative',
        background: 'rgba(255, 255, 255, 0.05)',
        overflow: 'hidden'
      }}
    >
      <MotionDiv
        className="origin-signature-line"
        initial={{ width: 0 }}
        animate={{ width: '100%' }}
        transition={{ duration: 0.8, ease: "circOut" } as any}
        style={{
          height: '100%',
          background: 'var(--color-accent-500)',
          opacity: 0.6,
          boxShadow: '0 0 8px var(--color-accent-500)'
        }}
      />
    </div>
  );
};

export default OriginSignatureLine;
